const WAX_BASE_URL = 'https://wax-server.fly.dev';
// const WAX_BASE_URL = 'http://localhost:3000';

const publishText = async (text, signal) => {
    try {
        const response = await fetch(`${WAX_BASE_URL}/publishText`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ text }),
            signal
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error publishing text:', error);
        throw error;
    }
}

const publishUrl = async (url, signal) => {
    try {
        const response = await fetch(`${WAX_BASE_URL}/publish`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ url }),
            signal
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error publishing URL:', error);
        throw error;
    }
}

export { publishText, publishUrl };